<div *ngIf="isLoading" class="ui active inverted dimmer">
  <div class="ui dimmer loader"></div>
</div>


<div *ngIf="anObject.id; else noObjectId"
     [formGroup]="formGroup"
     class="ui section">

  <ng-container *ngIf="!responsibleUsers; else responsibleUsersExists">
    <sui-message class="info" [isDismissable]="false">
      <p>Ответственные еще не назначены. Можно их
        <button class="ui mini primary button" (click)="onCreateButton()">Назначить</button>
      </p>
    </sui-message>
  </ng-container>
  <ng-template #responsibleUsersExists>
    <div class="fields">
      <div class="ten wide inline field">
        <sui-message class="info" [isDismissable]="false">
          <p>Ответственные сохраняются сразу, независимо от кнопки Сохранить и Согласовать. <br>
            Есть возможность
            <button class="ui mini primary button" (click)="onRecreateButton()">пересоздать</button>
            в случае их ролевого несоответствия.
          </p>
        </sui-message>
      </div>
    </div>
    <div *ngFor="let respUser of responsibleUsers; trackBy: trackById" class="fields">
      <div class="ten wide inline field" style="display: inline-flex; align-items: center">
        <label>{{getResponsibilityTypeName(respUser.responsibilityTypeId)}}:</label>
        <dx-combobox
          [isReadOnly]="!respUser.isTypeEditable"
          [controlId]="'responsibleUserCombo'+respUser.id"
          [formControlInstance]="formGroup.controls['responsibleUserCombo'+respUser.id]"
          style="flex: 1 1 auto;"
          [clearable]="true"
          [options]="{
            labelField: 'fio',
            valueField: 'id',
            isSearchable: true
          }"
          [elements]="this.usersDict"
          (change)="onValueChange(respUser.id, $event)">
        </dx-combobox>
      </div>
    </div>
  </ng-template>
</div>


<ng-template #noObjectId>
  <sui-message class="info" [isDismissable]="false">
    <div class="header">
      Информация
    </div>
    <p>Нужно сохранить документ, прежде чем назначать ответственных</p>
  </sui-message>
</ng-template>
